<div class="exceptions-wrapper">
    <div class="desav-container">
      <div class="selector-div-wrapper">
        <p>Activar</p>
        <div class="form-check form-switch">
          <input
            class="input-switch-sm form-check-input"
            type="checkbox"
            role="switch"
            id="exceptions-switch"
            [(ngModel)]="tool.enabled"
            [checked]="tool.enabled" />
        </div>
      </div>
    </div>
    <div class="upload-file-container" *ngIf="tool.enabled">
      <p class="title"></p>
      <div
        class="file-content"
        *ngIf="!postedFile && !tool.data; else fileExisting"
        fileDropZone
        (fileDrop)="onFileDropped($event)">
        <p class="text-drag-file">Arrastra el archivo aquí</p>
        <p class="text-drag-file divisor">— o —</p>
        <input type="file" class="file-uploader" (change)="onFileSelected($event)" #fileUpload />
        <button class="upload-file-btn" (click)="fileUpload.click()">Seleccionar archivo de tu ordenador</button>
      </div>
      <a class="btn-transparent" [href]="downloadTemplate" download="exceptions_template.json">Descargar plantilla</a>
      <ng-template #fileExisting>
        <div class="file-content active">
          <div class="file-box">
            <span *ngIf="postedFile?.name">{{ postedFile.name }}</span>
            <button class="element-action-btn" (click)="deleteDroppedFile()">
              <img id="delete" alt="" />
            </button>
          </div>
          <div class="jsonviewer-wrapper" *ngIf="tool.data">
            <ngx-json-viewer *ngIf="tool.data" [json]="tool.data" [expanded]="false"></ngx-json-viewer>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  